import React from 'react'
import ReactDOM from 'react-dom'
import App from './app'
import './styles/tailwind.css'

ReactDOM.render(
  <React.StrictMode>
    <App debug={true}/>
  </React.StrictMode>,
  document.getElementById('root')
)